<template>
    <div>
      <div >
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="block">
              <el-date-picker size="mini" v-model="params.times" clearable type="daterange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="7">
            <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-button size="mini" type="primary" @click="syncCoupon()">同步券包</el-button>
        </el-row>
  
        <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
          <el-table-column prop="package_num_id" label="券包编号"></el-table-column>
          <el-table-column prop="package_name" label="券包名称"></el-table-column>
          <el-table-column prop="total_fee" label="原总价">
            <template slot-scope="scope">
                {{ scope.row.total_fee/100 }}元
            </template>
          </el-table-column>
          <el-table-column prop="retail_fee" label="现售价">
            <template slot-scope="scope">
                {{ scope.row.retail_fee/100 }}元
            </template>
          </el-table-column>
          <el-table-column prop="stock_qty" label="券包库存"></el-table-column>
          <el-table-column prop="coupon_count" label="券包里的张数"></el-table-column>
          <el-table-column prop="sale_package_count" label="已售券包数量"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
              <el-tag type="success" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
            <template slot-scope="scope">
                {{ scope.row.created_at_text }}
            </template>
          </el-table-column> 
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success"> 开启</el-tag>
              <el-tag v-else type="info">关闭</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="show(scope.row)">查看</el-button> 
            </template>
          </el-table-column>
        </el-table>
        <div class="content-center content-top-padded">
          <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
            :page-size="params.pagesize">
          </el-pagination>
        </div>
        <el-dialog
          title="详细"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <template>
            <el-table
              :data="row">
              <el-table-column
                prop="title"
                label="券名称" >
              </el-table-column>
              <el-table-column
                prop="series"
                label="券规则ID" >
              </el-table-column> 
              <el-table-column
                prop="coupontype"
                label="券类型" >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.coupontype == 0">
                        折扣券
                    </el-tag>
                    <el-tag v-if="scope.row.coupontype == 1">
                      代金券
                    </el-tag>
                    <el-tag v-if="scope.row.coupontype == 2">
                      免邮券
                    </el-tag>
                    <el-tag v-if="scope.row.coupontype == 8">
                      兑换券
                    </el-tag>
                    <el-tag v-if="scope.row.coupontype == 9">
                      服务券
                    </el-tag>
                </template>
              </el-table-column> 
              <el-table-column
                prop="face_value"
                label="券面值" >
              </el-table-column> 
              <el-table-column
                prop="stock_qty"
                label="券库存" >
              </el-table-column> 
              <el-table-column
                prop="status"
                label="券状态" >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 2">
                       已审核
                    </el-tag> 
                    <el-tag v-if="scope.row.status == 3">
                       终止
                    </el-tag> 
                </template>
              </el-table-column> 
            </el-table>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <router-view></router-view>
    </div>
  </template>
  <script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getKaquanPackageList,syncKaquanPackageList,getKaquanPackageInfo
  } from "@/api/cardticket";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        dialogVisible:false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible: false,
        total_count: 0,
        params: {
          page: 1,
          pagesize: 20,
        },
        dataList: [],
        loading: false,
        row:[],
      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: {
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      syncCoupon(){
      this.$confirm('确定要优惠券包到多店铺？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            syncKaquanPackageList().then((res)=>{
              if(res){
                loading.close();
                  this.$message({
                  message: res.data.data.msg,
                  type: 'success',
                  duration: 2000
                })
              }
              
            })
          }
        done()
        }
      })
    },
    show(row) {
        this.dialogVisible = true;
        this.row=row.couponrule_infos
        // getKaquanPackageInfo(id).then((response)=>{
        //   this.row = response.data.data;
          console.log(this.row)
        // })
      },
      getDataList() {
        this.loading = true;
        getKaquanPackageList(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
      },
      del(id, index) {
        this.$confirm('确定删除么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delOrderCard(id).then(response => {
            this.$message({
              type: "success",
              message: response.data.data.msg,
            })
            this.dataList.splice(index, 1);
          })
        });
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
    },
    mounted() {
      this.getDataList();
    },
    provide() {
      return {
        refresh: this.getDataList
      }
    },
  
  };
  </script>
  <style scoped lang="scss"></style>
  


// WEBPACK FOOTER //
// list.vue?ada2f6ac